import Model from "./model";
import _ from "lodash";

export default new Model({
  resource : "user",
  inputs:[
    {label:"ID", nameAttr:"id", default:0, required: true, type:"text", width: 60},
    {label:"RUT", nameAttr:"rut", default:"-", required: true, type:"text", width:120},
    {label:"Nombre", nameAttr:"name", default:"", required: true, type:"text", width: 300},
    {label:"Email", nameAttr:"email", default:"", required: true, type:"text", width: 300},
    {label:"Nueva Contraseña", nameAttr:"password", default:"", required: true, type:"password", noSearch: true, width: 200},

    {
      label      : "Roles",
      nameAttr   : "roles",
      renameAttr : "rol",
      itemText   : "title",
      itemValue  : "name",
      rootPath   : "data.roles",
      default    : [],
      required   : true,
      type       : "multiSelect",
      model      : "rolModel",
      width      : 150,
    //mapeo de value, cuando vienen de un model separado
    //lee los array con formato {add: Boolean, name: String}
    /*
    mapValueFn:(itemForm, item) => {
      return _.map(item.roles, (rol)=>{
        var find =  _.find(itemForm.list, {name: rol});
        return find ? find.id : null;
      })
    },
    */
    //mapeo de value, previo a guardar
    //guarda los array con formato {add: Boolean, name: String}
    mapSaveFn: (nodeInput) => {

      var add    = _.filter(nodeInput.value         , val => nodeInput.valueOriginal.indexOf(val) == -1 );
      var remove = _.filter(nodeInput.valueOriginal , val => nodeInput.value.indexOf(val) == -1 );

      var addFiltered    = _.map(add    , name => _.find(nodeInput.list, { name: name }) )
      var removeFiltered = _.map(remove , name => _.find(nodeInput.list, { name: name }) )

      var r = _.concat(
        _.map( addFiltered    , itemList => ( { add:1, name: itemList.name } ) ),
        _.map( removeFiltered , itemList => ( { add:0, name: itemList.name } ) )
      );

      return r;

    }
  },
  ]
});
